import React, { Component } from 'react';
import { Modal, Button, Select, Label, Form, Segment, Grid, Popup, Radio, Message } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../../_utils/config';
import swal from 'sweetalert'

export default class STSAdd extends Component {
   constructor(props){
      super(props);
      this.state = {
         dataBP: props.data ? props.data : null,
         parafs: [],
         rekening_banks: [],
         kuasas: [],
         data: {
            paraf: null,
            rekening_bank: null,
            kuasa: null,
            mewakili: {
               nip_mewakili: "",
               nama_mewakili: "",
               jabatan_mewakili: "",
            },
            uraian: "",
            is_terwakili: false
         },
         loading: false,
         disabled_btn_save: false,
         data_bp: props.data_bp ? props.data_bp : null,
         
      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onChangeParaf = this.onChangeParaf.bind(this);
      this.onChangeRekeningBank = this.onChangeRekeningBank.bind(this);
      this.onChangeKuasa = this.onChangeKuasa.bind(this);
      this.onChangeMewakili = this.onChangeMewakili.bind(this);
      this.onToggleRadio = this.onToggleRadio.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this)
   }

   handleKeyPress(event){
      if(event.key === '/' || event.key === '%' || event.key === "'" || event.key === '"'){
         swal("Maaf, penggunaan spesial karakter (\", ', %, /) pada isian nama atau keterangan diblock", {
            icon: "warning",
         });
      }
   }

   onToggleRadio(){
      const { nama_mewakili, nip_mewakili, jabatan_mewakili } = this.state.data.mewakili;
      let nama = !this.state.data.is_terwakili ? nama_mewakili : "";
      let nip = !this.state.data.is_terwakili ? nip_mewakili : "";
      let jabatan = !this.state.data.is_terwakili ? jabatan_mewakili : "";

      this.setState({
         data: {
               ...this.state.data,
                  mewakili: {
                     ...this.state.data.mewakili, 
                        nama_mewakili: nama,
                        nip_mewakili: nip,
                        jabatan_mewakili: jabatan,
                  },
                  is_terwakili: !this.state.data.is_terwakili
            }
      })
   }
  
   componentWillMount(){
      this.getParafData();
      this.getKuasaData();
      this.getRekeningBankData();
   }

   getParafData(){
      fetch(`${BaseURLDev}/paraf`, { headers })
      .then(response => {
         if(!response.ok){
            swal("", "Load data gagal", "error");            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const parafs = []
         resJSON.data.map(function(item,i){
            parafs.push({
               'value': item.id,
               'text': `[${item.kode}] ${item.nama}`,
               'key': i      
            })
         })
         this.setState({parafs:parafs})
         return
      })
   }

   getRekeningBankData(){
      fetch(`${BaseURLDev}/rekening_bank`, { headers })
      .then(response => {
         if(!response.ok){
            swal("", "Load data gagal", "error");            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const rekening_banks = []
         resJSON.data.map(function(item,i){
            rekening_banks.push({
               'value': item.id,
               'text': `[${item.kode_akun}] ${item.nama_akun}`,
               'key': i      
            })
         })
         this.setState({rekening_banks:rekening_banks})
         return
      })
   }

   getKuasaData(){
      fetch(`${BaseURLDev}/kuasa`, { headers })
      .then(response => {
         if(!response.ok){
            swal("", "Load data gagal", "error");      
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const kuasas = []
         resJSON.data.map(function(item,i){
            kuasas.push({
               'value': item.id,
               'text': `[${item.kode}] ${item.nama}`,
               'key': i      
            })
         })
         this.setState({kuasas:kuasas})
         return
      })
   }

   onChangeParaf = (e, el) => this.setState({data: {...this.state.data,paraf:el.value}})
   onChangeRekeningBank = (e, el) => this.setState({data: {...this.state.data,rekening_bank:el.value}})
   onChangeKuasa = (e, el) => this.setState({data: {...this.state.data,kuasa:el.value}})
   
   onChange = (e) => {
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({data: {...this.state.data, [e.target.name]: text}})      
   }

   onChangeMewakili = (e) => this.setState({data: {...this.state.data, mewakili: {...this.state.data.mewakili, [e.target.name]:e.target.value}}})
   onSubmit = (e) => {
      const { rekening_banks } = this.state;
      const { paraf, uraian, kuasa, is_terwakili, mewakili, rekening_bank } = this.state.data;
      if(rekening_banks.length){
         if(rekening_bank===null || rekening_bank===""){
            swal("", 'Rekening Bank Penerima harus dipilih terlebih dahulu', "error");
            this.setState({ disabled_btn_save: false })
            return false;
         }
      }

      if(is_terwakili){
         if(mewakili.nama_mewakili===null || mewakili.nama_mewakili===""){
            swal("", 'Nama Pejabat yang mewakili harus diisi terlebih dahulu', "error");
            this.setState({ disabled_btn_save: false })
            return false;   
         }else if(mewakili.nip_mewakili===null || mewakili.nip_mewakili===""){
            swal("", 'NIP Pejabat yang mewakili harus diisi terlebih dahulu', "error");
            this.setState({ disabled_btn_save: false })
            return false;   
         }else if(mewakili.jabatan_mewakili===null || mewakili.jabatan_mewakili===""){
            swal("", 'Jabatan Pejabat yang mewakili harus diisi terlebih dahulu', "error");
            this.setState({ disabled_btn_save: false })
            return false;   
         }
      }
      if(paraf===null || paraf===""){
         swal("", 'Pejabat/Bendahara Penerima yang menyetujui harus dipilih terlebih dahulu', "error");
         this.setState({ disabled_btn_save: false })
         return false;
      }else if(kuasa===null || kuasa===""){
         swal("", 'Pejabat Kuasa Pengguna Anggaran (KPA) harus dipilih terlebih dahulu', "error");
         this.setState({ disabled_btn_save: false })
         return false;
      }else if(uraian==="" || uraian===null){
         swal("", 'Uraian/Keterangan STS harus diisi terlebih dahulu', "error");
         this.setState({ disabled_btn_save: false })
         return false;
      }else{
         swal({
            title: `Benar STS ini akan dibuat?`,
            text: "Apakah anda tetap melanjutkan?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
         })
         .then((will) => {
            if (will) {
               e.preventDefault();
               this.setState({ loading: true });
               var data_ = {}
               if(this.state.data_bp===null){
                  data_['data'] = this.state.data
                  data_['bp'] = this.state.dataBP
               }else if(this.state.dataBP===null){
                  data_['data']=this.state.data
                  data_['bp'] = this.state.data_bp
                  data_['q'] = 1
               }

               fetch(`${BaseURLDev}/sts`,{
                  headers,
                  method: 'POST',
                  body: JSON.stringify(data_)
               })
               .then(response => {
                  if (!response.ok) { 
                        this.setState({loading: false });
                        swal("Pembuatan STS gagal", { icon: 'error' })
                        return Promise.reject(response.statusText);
                     }
                  return response.json()
               })
               .then(parsedJSON => {
                  swal("Pembuatan STS selasai",{icon: 'success'}).then(()=>{
                     window.location.href="/b/sts"
                  })
               })
            }
            return false;
         });
      }
   }

   render() {
      const { uraian } = this.state.data;
      const { rekening_banks } = this.state;
      return (
         <div>
            <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="medium"
            >
         <Modal.Header>
            Pembuatan STS
         </Modal.Header>
         
         <Modal.Content>
            <Message
                  error
                  header='** Penting'
                  content='STS ini hanya bisa dibuat jika user login menggunakan tahun anggaran yang sama pada tahun saat ini'
            />
            <Segment padded>
               
               <Label attached='top' color="violet">Data Input STS</Label>                        
               <Form onSubmit={this.onSubmit} loading={this.state.loading}>
                  {rekening_banks.length ?
                  <span>
                     <Label>Rekening Bank Penerima</Label> 
                     <Form.Field 
                           control={Select} search 
                           onChange={this.onChangeRekeningBank} 
                           options={this.state.rekening_banks} 
                           name="rekening_bank" 
                           placeholder='Pilih Rekening Bank Penerima'
                           title='Pilih Rekening Bank Penerima'
                     /><br />
                  </span> : ""}

                  <Label>Bendahara Penerima</Label> 
                  <Form.Field 
                        control={Select} search 
                        onChange={this.onChangeParaf} 
                        options={this.state.parafs} 
                        name="paraf" 
                        placeholder='Pilih Bendahara Penerima'
                        title='Pilih Bendahara Penerima'
                  />
                  <Grid>
                     <Grid.Column width={10}>
                        <Label>Pejabat (KPA) Kuasa Pengguna Anggaran</Label> 
                        <Form.Field 
                              control={Select} search 
                              onChange={this.onChangeKuasa} 
                              options={this.state.kuasas} 
                              name="kuasa" 
                              placeholder='Pilih kuasa pengguna anggaran'
                              title='Pilih kuasa pengguna anggaran' 
                        />
                     </Grid.Column>
                     <Grid.Column width={6}>
                        <Label>Apakah Pejabat (KPA) diwakili?</Label>
                        <Popup
                           trigger={
                              <Radio toggle style={{marginBottom:'10px'}}
                                 onChange={this.onToggleRadio}/> 
                           }
                           header="Apakah Pejabat Diwakilkan?"
                           content='Input Pejabata Mewakili'
                           on='hover'
                           inverted
                        />
                     </Grid.Column>
                  </Grid>
                  {this.state.data.is_terwakili ?
                     <Grid>
                         <Grid.Column width={16}>
                           <Label>Nama Pejabat Mewakili</Label>
                           <Form.Input value={this.state.data.mewakili.nama_mewakili} onChange={this.onChangeMewakili}
                              name="nama_mewakili" placeholder='Nama Pejabat Mewakili'
                              title='Nama Pejabat Mewakili' />
                        </Grid.Column>
                        <Grid.Column width={8}>
                           <Label>NIP Pejabat Mewakili</Label>
                           <Form.Input value={this.state.data.mewakili.nip_mewakili} onChange={this.onChangeMewakili}
                              name="nip_mewakili" placeholder='NIP Pejabat Mewakili'
                              title='NIP Pejabat Mewakili' />
                        </Grid.Column>
                        <Grid.Column width={8}>
                           <Label>Jabatan Pejabat Mewakili</Label>
                           <Form.Input value={this.state.data.mewakili.jabatan_mewakili} onChange={this.onChangeMewakili}
                              name="jabatan_mewakili" placeholder='Jabatan Pejabat Mewakili'
                              title='Jabatan Pejabat Mewakili' />
                        </Grid.Column>
                     </Grid>
                  : ""}
                  {/* <Label>Keterangan STS</Label> */}
                  <Form.TextArea 
                     style={{'height': '150px', "marginTop": "15px"}}
                     value={uraian} 
                     onChange={this.onChange} 
                     onKeyPress={this.handleKeyPress}
                     placeholder='Keterangan STS'
                     title='Keterangan STS' name="uraian" 
                  />

                  <Form.Button disabled={this.state.disabled_btn_save} size='medium' positive>Buat STS</Form.Button>
               </Form>
            </Segment>
         </Modal.Content>
         <Modal.Actions>
            <Button negative onClick={this.props.onClose}>Tutup</Button>
         </Modal.Actions>
         </Modal>
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/_addsts/STSAdd.js